module.exports = __webpack_public_path__ + "static/tat-30-caa8c6d8cd573fb4ee0eca1dc81d9178.jpg";